import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('TicketsService', TicketsService);

  TicketsService.$inject = ['RestResource'];

  function TicketsService(RestResource) {
    let apiUrl = environment.apiEndpoint + 'tickets';

    let service = {
      getTicket: getTicket,
    };

    return service;

    ////////////////

    function getTicket(option, id, subdomain, apiKey, lang) {
      // itinerary / voucher
      let url = `${apiUrl}/${id}/${option}/?sub=${subdomain}&cak=${apiKey}&lang=${lang}`;

      return RestResource.request(
        'get',
        url,
        {},
        function (response) {
          return response.data;
        },
        function () {
          return false;
        }
      );
    }
  }
})();
